import { Component, Input } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { RouterLink, RouterModule } from '@angular/router';
import { Product } from '../../model/product.model';
import { environment } from '../../environments/environment';
import { Cart, CartItem } from '../../model/cart.model';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { GuestService } from '../../service/guest.service';
import { StateService } from '../../service/state.service';
import { StorageService } from '../../service/storage.service';
import { UserService } from '../../service/user.service';
import { GUEST_CART_ID, TOKEN } from '../../constants/constant';

@Component({
  selector: 'app-product-card',
  imports: [ RouterModule,RouterLink,CommonModule],
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent {
  @Input() product!: Product;
  imageUrl = environment.imageUrl
  debounceTimer: any;
  token: string | null;
  guestCartId: string | null;
  unsubscribe$ = new Subject();
  constructor(private stateService: StateService,
    private guestService: GuestService,
    private localService: StorageService,
    private userService: UserService,
    private toastr: ToastrService,) { }

  ngOnInit() {
    this.guestCartId = this.localService.getItem(GUEST_CART_ID);
    this.token = this.localService.getItem(TOKEN);
  }

  addToCart() {
    const cart: CartItem = {
      skuId: this.product.skuId.toString(),
      quantity: 1,
      flag: 0
    };

    if (this.token) {
      this.userService.addProductUserCart(cart).pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: res => {
            this.toastr.success(res.meta.status_message)
            this.stateService.sendCartUpdated(true);
          },
          error: (err) => {
            this.toastr.error("Something Went Wrong")
          }
        });
    } else {
      this.guestService.addProductGuestCart(cart, this.guestCartId).pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: res => {
            this.toastr.success(res.meta.status_message)
            this.stateService.sendCartUpdated(true);
          },
          error: (err) => {
            this.toastr.error("Something Went Wrong")
          }
        });
    }
  }
}
